import { OrganizationId, Region } from '@kaizenplatform/hugot-entity';
// import { Redirect } from 'react-router';
// import { createPath } from 'history';
import { parse } from 'qs';
import { createElement, FC, useContext, useEffect } from 'react';

import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';
// import ExtendedOrganization from '../../entity/ExtendedOrganization';
import Page from '../page/DesignInspirationsListPage';
// import mergeUrlQuery from '../../utility/mergeUrlQuery';

type Props = {
  visible?: boolean;
  className?: string;
};

const DesignInspirationsListPage: FC<Props> = ({ visible = false, className }) => {
  const state = useContext(StateContext);
  const history = useContext(HistoryContext);
  const dependency = useContext(DependencyContext);

  const query = parse(state.location.search.slice(1));
  const organizationId: OrganizationId = query.org || null;

  const region: Region =
    state.lastAccessedOrganization != null && state.lastAccessedOrganization.businessRegion.key
      ? state.lastAccessedOrganization.businessRegion.key
      : 'jp';

  useEffect(() => {
    dependency.projectDesignInspirationUsecase.closeDesignInspirationScreen();
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);

  // 以下の処理は単一のページでなければ不要
  // useEffect(() => {
  //   dependency.authenticationUsecase.needSignedIn();

  //   if (organizationId) {
  //     dependency.organizationUsecase.refreshPointBalance(organizationId);
  //   }
  // }, [organizationId]);

  // if (!organizationId) {
  //   let organization!: ExtendedOrganization;

  //   if (state.lastAccessedOrganization) {
  //     organization = state.lastAccessedOrganization;
  //   } else if (state.availableOrganizations.items.size >= 1) {
  //     organization = state.availableOrganizations.items.first()! as ExtendedOrganization;
  //   }

  //   if (organization) {
  //     return <Redirect to={createPath(mergeUrlQuery(history.location, { org: organization.id }))} />;
  //   }
  // } else {
  //   if (!state.availableOrganizations.items.some(item => item.id === organizationId)) {
  //     return <Redirect to="/design_inspirations" />;
  //   }
  // }

  const handleClickNextButton = (designInspirationCaseId: string) => {
    dependency.projectDesignInspirationUsecase.toNext({ organizationId, designInspirationCaseId });
  };

  // setLocationPath(history.location.pathname);
  return !state.fatalError &&
    state.authentication.fetching === 0 &&
    state.authentication.signedInUser &&
    state.projectEditing.projectType &&
    state.projectEditing.projectType.designInspirationCategories ? (
    <Page
      loading={state.fullScreenSpinner.necessity >= 1}
      catgories={state.projectEditing.projectType.designInspirationCategories}
      onClickBackButton={() => {
        dependency.projectDesignInspirationUsecase.closeDesignInspirationScreen();
      }}
      onClickNextButton={({ designInspirationCaseId }: { designInspirationCaseId: string }) => {
        dependency.projectDesignInspirationUsecase.closeDesignInspirationScreen();
        handleClickNextButton(designInspirationCaseId);
      }}
      className={className}
      open={visible}
      region={region}
    />
  ) : null;
};

export default DesignInspirationsListPage;
